import React from 'react';
import { Typography, List, ListItem, ListItemText, Paper } from '@material-ui/core';

function Overview({ someData, onNext, onBack }) {
  const familyPlan = someData?.family_plan?.toUpperCase() || '';

  const plans = {
    ESSENTIAL: {
      title: 'O plano Essencial contempla:',
      items: [
        'Emissão da cópia digital do assento português',
        'Análise da documentação',
        'Pagamento das taxas portuguesas',
        'Protocolo do Pedido em Portugal',
        'Atendimento Omnichannel (e-mail, whatsapp, loja)',
        'Emissão dos antecedentes criminais brasileiros',
        'Envio digital do registro português',
      ],
    },
    PREMIUM: {
      title: 'O plano Premium contempla:',
      items: [
        'Emissão da cópia digital do assento português',
        'Análise da documentação',
        'Pagamento das taxas portuguesas',
        'Protocolo do Pedido em Portugal',
        'Atendimento Omnichannel (e-mail, whatsapp, loja)',
        'Emissão dos antecedentes criminais brasileiros',
        'Envio digital do registro português',
        'Emissão das certidões brasileiras',
        'Custas cartoriais de emissão',
        'Apostilamento de Haia das certidões do Brasil e outros documentos',
        'Grupo exclusivo da família no WhatsApp para suporte adicional',
      ],
    },
    EXCLUSIVE: {
      title: 'O plano Exclusivo contempla:',
      items: [
        'Emissão da cópia digital do assento português',
        'Análise da documentação',
        'Pagamento das taxas portuguesas',
        'Protocolo do Pedido em Portugal',
        'Atendimento Omnichannel (e-mail, whatsapp, loja)',
        'Emissão dos antecedentes criminais brasileiros e internacionais',
        'Envio digital do registro português',
        'Emissão das certidões brasileiras',
        'Custas cartoriais de emissão',
        'Apostilamento de Haia das certidões do Brasil e outros documentos',
        'Grupo exclusivo da família no WhatsApp para suporte adicional',
        'Retificações administrativas',
        'Cashback para valores em ações judiciais no Brasil de retificação',
        'Custos com documentos para resolução de exigências',
      ],
    },
  };

  const planData = plans[familyPlan];

  return (
    <Paper style={{ padding: 24 }}>
      {planData ? (
        <>
          <Typography variant="h5" gutterBottom>
            {planData.title}
          </Typography>

          <List>
            {planData.items.map((item, index) => (
              <ListItem key={index} disableGutters>
                <ListItemText primary={`• ${item}`} />
              </ListItem>
            ))}
          </List>
        </>
      ) : (
        <Typography color="textSecondary">
          Não foi possível identificar o plano selecionado.
        </Typography>
      )}

    </Paper>
  );
}

export default Overview;
